import axios from '@/axios';
import {dev} from '@/api/url';

const baseUrl = dev;
const headers = {
  'Content-Type': 'application/json',
};

const config = {
  timeout: 30000,
  method: null,
  emulateJSON: true,
  url: '',
  headers,
  data: null,
};

export default {
  getDeletedItems: () => {
    config.url = `${baseUrl}/api/trash/list`;
    config.method = "get";

    return axios.request(config)
      .then(res => res.data)
      .catch(err => {
        console.error('ゴミ箱データを取得中にエラーが発生しました:', err.message || '予期しないエラー');
        return 'ゴミ箱データを取得中にエラーが発生しました。';
      });
  },
  restoreItem: (requestData) => {
    const config = {
      url: `${baseUrl}/api/trash/resurrection`,
      method: "post",
      data: requestData
    };

    return axios.request(config)
      .then(res => {
        if (res.data && res.data.message) {
          return res.data.message;
        }
        return "アイテムが正常に復元されました。";
      })
      .catch(err => {
        if (err.response) {
           if (err.response.status === 422 || err.response.status === 423) {
              throw err;
            }
          }

        let ErrMsg = '';

        if (err.code === 'ERR_NETWORK') {
          ErrMsg = 'ネットワークエラーが発生しました。';
        } else if (err.response) {
          if (err.response.status === 404) {
            ErrMsg = '復元するアイテムが見つかりませんでした。';
          } else if (err.response.status === 500) {
            ErrMsg = 'サーバーエラーが発生しました。後ほど再試行してください。';
          } else {
            ErrMsg = err.response.data.message || '復元中にエラーが発生しました。';
          }
        } else {
          ErrMsg = err.message || '予期しないエラーが発生しました。';
        }
      
        console.error("Error Response:", err.response);
        throw new Error(ErrMsg);
      });
        },
        
  deleteItem: (requestData) => {
    const config = {
      url: `${baseUrl}/api/trash/delete`,
      method: "post",
      data: requestData
    };

    return axios.request(config)
      .then(res => {
        if (res.data && res.data.message) {
          return res.data.message;
        }
        return "アイテムが正常に削除されました。";
      })
      .catch(err => {
        let ErrMsg = '';

        if (err.code === 'ERR_NETWORK') {
          ErrMsg = 'ネットワークエラーが発生しました。';
        } else if (err.response) {
          if (err.response.status === 404) {
            ErrMsg = '削除するアイテムが見つかりませんでした。';
          } else if (err.response.status === 500) {
            ErrMsg = 'サーバーエラーが発生しました。後ほど再試行してください。';
          } else {
            ErrMsg = err.response.data.message || '削除中にエラーが発生しました。';
          }
        } else {
          ErrMsg = err.message || '予期しないエラーが発生しました。';
        }

        console.error("Error Response:", err.response);
        throw new Error(ErrMsg);
      });
  }
}
